import { render } from "./AddFiles.vue?vue&type=template&id=681e8e17&scoped=true"
import script from "./AddFiles.vue?vue&type=script&lang=js"
export * from "./AddFiles.vue?vue&type=script&lang=js"

import "./AddFiles.vue?vue&type=style&index=0&id=681e8e17&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-681e8e17"]])

export default __exports__